import { call, put, takeLatest } from 'redux-saga/effects';

import { getParsedFias } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getParsedFias, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* documentTypesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
